var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';

const app = {
    /** Initialize */
    init() {

        // Toggle navigation overlay
        this.toggleNavigationOverlay();

        // Toggle sub navigation
        this.toggleSubnavigation();

        // Toggle search box
        this.toggleSearchBox();

        // Initialize Sliders
        this.initSliders();

        // FAQ Toggle
        this.toggleFAQItems();

        // Toggle Tab Items 
        this.toggleTabItems();

        // Initialize popups
        this.initPopups();

        // Fade sections in on scroll
        this.fadeInOnScroll();

        // Toggle FAQ Tabs
        this.toggleFaqTabs();

        // Smooth scroll
        this.smoothScroll();

        // Toggle show more for prices
        this.toggleShowMoreForPrices();

        // Video play toggle
        this.videoPlayToggle();

        // Replace required text with star
        this.formReplaceRequiredWithStar();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },

    /** Toggle navigation overlay */
    toggleNavigationOverlay() {

        $('li.has-children').hover(function () {
            $(".navigation-overlay").toggleClass('is-visible');
            $("body").toggleClass('is-locked');
            $(this).find('ul').toggleClass('is-opened');
        });
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $(".hamburger").toggleClass('is-active');
        $(".navigation-items").toggleClass('is-visible');
        $("body").toggleClass('is-locked');
    },

    /** Toggle Sub navigation */
    toggleSubnavigation() {
        if ($(window).width() < 1025) {
            $("nav.navigation ul li.has-children > a.navlink span.toggle-subnav").click(function (e) {
                e.preventDefault();
                $('li.has-children').removeClass("is-opened").find("> ul").slideUp("slow");
                $(this).closest('li.has-children').toggleClass("is-opened").find("> ul").slideToggle("slow");

                if (!$(this).closest('a.navlink').hasClass('active')) {
                    $(this).closest('a.navlink').toggleClass("active");
                }
            });
        }
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header, main').toggleClass('is-scrolled', $(window).scrollTop() > 0);
    },

    /** Toggle search box */
    toggleSearchBox() {

        $('.search-icon').click(function () {
            $(this).toggleClass('is-active');
            $(".search-box").toggleClass('is-visible');
        });
    },

    /** Initialize Sliders */
    initSliders() {

        // Config image-content slider
        if ($('.image-content-slider .content').length) {
            $('.image-content-slider .content').slick({
                autoplay: false, autoplaySpeed: 3000, slidesToShow: 1,
                fade: true, dots: false, asNavFor: '.image-content-slider .image',
                arrows: true, nextArrow: '.custom-arrow', prevArrow: '.custom-arrow',
            });
        }

        if ($('.image-content-slider .image').length) {
            $('.image-content-slider .image').slick({
                autoplay: false, autoplaySpeed: 3000, slidesToShow: 1,
                dots: false, arrows: true, asNavFor: '.image-content-slider .content',
                nextArrow: '.custom-arrow', prevArrow: '.custom-arrow',
            });
        }

        if ($('.image-heading-slider .cards-holder').length) {
            $('.image-heading-slider .cards-holder').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                nextArrow: '.image-heading-slider .custom-arrow.slick-next',
                prevArrow: '.image-heading-slider .custom-arrow.slick-prev',
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 1279,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },

                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },

                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },
                ]
            });
        }

        if ($('.arrangement-slider .cards-holder').length) {

            $('.arrangement-slider .cards-holder').each(function () {
                var slickInduvidual = $(this);
                slickInduvidual.slick({
                    nextArrow: slickInduvidual.closest('.arrows-wrapper').find('.arrangement-slider .custom-arrow.slick-next'),
                    prevArrow: slickInduvidual.closest('.arrows-wrapper').find('.arrangement-slider .custom-arrow.slick-prev'),
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 2000,
                    responsive: [
                        {
                            breakpoint: 9999,
                            settings: "unslick"
                        },
                        {
                            breakpoint: 1279,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },

                        {
                            breakpoint: 1023,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },

                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },
                    ]
                });
            })


        }

        if ($('.reviews .reviews-container').length) {
            $('.reviews .reviews-container').slick({
                slidesToShow: 3,
                autoplay: false,
                autoplaySpeed: 6000,
                infinite: true,
                arrows: false,
                dots: false,
                nextArrow: '.reviews .custom-arrow.slick-next',
                prevArrow: '.reviews .custom-arrow.slick-prev',

                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: false,
                            arrows: true
                        }
                    },

                    {
                        breakpoint: 481,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: true
                        }
                    },
                ]
            });
        }

        if ($('.slider-cards .slider-cards-container').length) {
            $('.slider-cards .slider-cards-container').each(function () {
                var slickInduvidual = $(this);
                slickInduvidual.slick({
                    nextArrow: slickInduvidual.closest('.arrows-wrapper').find('.custom-arrow.slick-next'),
                    prevArrow: slickInduvidual.closest('.arrows-wrapper').find('.custom-arrow.slick-prev'),
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 6000,
                    infinite: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                dots: false,
                                arrows: true
                            }
                        },

                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: true
                            }
                        },
                    ]
                });
            })
        }

        if ($('.jobs-slider .jobs-slider-container').length) {

            if ($(window).width() > 1023) {

                var amount = $('.jobs-slider-container .jobs-slider-card').length;

                var slidesToShow = '';
                var arrows = true;

                if (amount <= 3) {
                    slidesToShow = amount;
                    arrows = false;
                    $('.jobs-slider .custom-arrow').addClass('hide');
                } else {
                    slidesToShow = 3;
                }
            }

            $('.jobs-slider .jobs-slider-container').slick({
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 6000,
                infinite: true,
                dots: false,
                arrows: arrows,
                nextArrow: '.jobs-slider .custom-arrow.slick-next',
                prevArrow: '.jobs-slider .custom-arrow.slick-prev',

                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: true
                        }
                    },

                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: true
                        }
                    },
                ]
            });

        }
    },

    initPopups() {
        if ($('.popup.info').length) {
            setTimeout(function () {
                if (!document.cookie.match(/^(.*;)?\s*info_popup\s*=\s*[^;]+(.*)?$/)) {
                    $.fancybox.open({
                        src: '#infoPopup',
                        type: 'inline',
                        touch: false,
                        smallBtn: true,
                        clickSlide: false,
                        buttons: [""],
                        openEffect: 'none',
                        closeEffect: 'none',
                        clickOutside: 'close',
                    });

                    // Set a cookie so the popup isn't shown every time on page reload
                    function createCookie(name, value, minutes) {
                        if (minutes) {
                            var date = new Date();
                            date.setTime(date.getTime() + (minutes * 60 * 1000));
                            var expires = "; expires=" + date.toGMTString();
                        } else {
                            var expires = "";
                        }
                        document.cookie = name + "=" + value + expires + "; path=/";
                    }

                    createCookie("info_popup", "clicked", 10);
                }
            }, 5000);
        }

        $('.close-popup').click(function () {
            $.fancybox.close();
        });
    },

    /** Toggle FAQ items */
    toggleFAQItems() {
        $('.faq .question-toggle').click(function (e) {
            e.preventDefault();
            var $this = $(this);
            $(this).toggleClass('is-opened');

            if ($this.next().hasClass('show')) {
                $this.next().removeClass('show');
                $this.next().slideUp(350);
            } else {
                $this.parent().parent().find('.question .answer').removeClass('show');
                $this.parent().parent().find('.question .answer').slideUp(350);
                $this.next().toggleClass('show');
                $this.next().slideToggle(350);
            }
        });
    },

    /** Toggle Tab Items */
    toggleTabItems() {

        $('.tabs-holder ul.tabs-list li.tab:not(:first)').addClass('inactive');
        $('.tabs-holder .tab-content').hide();
        $('.tabs-holder .tab-content:first').show();

        $('.tabs-holder ul.tabs-list li.tab').click(function () {
            var t = $(this).attr('id');
            if ($(this).hasClass('inactive')) {
                $('.tabs-holder ul.tabs-list li.tab').addClass('inactive');
                $(this).removeClass('inactive');

                $('.tabs-holder .tab-content').hide();
                $('#' + t + 'C').fadeIn('slow');
            }
        });
    },

    /** Fade sections in on scroll */
    fadeInOnScroll() {
        $.fn.initFadeIn = function () {
            $('.section').each(function () {
                let top_of_element = $(this).offset().top + 150;
                let bottom_of_element = $(this).offset().top + $(this).outerHeight();
                let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                let top_of_screen = $(window).scrollTop();
                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
                    $(this).addClass('is-visible');
                }
            });
        };
        $.fn.initFadeIn();
        $(window).scroll(function () {
            $.fn.initFadeIn();
        });
    },

    toggleFaqTabs() {
        $('.section-filter .filters .term').on('click', function () {
            if (!$(this).hasClass('active')) {
                $('.term.active').removeClass('active');
                $(this).addClass('active');
            }

            $('.section-questions .inner .content-wrapper.active').removeClass('active').addClass('hide');
            $('.section-questions .inner #' + $(this).data('tab-name')).removeClass('hide').addClass('active');
        });

        $('.section-filter .filters .term').first().addClass('active');
        $('.section-questions .inner .content-wrapper').first().removeClass('hide').addClass('active');
    },


    smoothScroll() {
        if ($(window).width() > 780) {
            $(document).on('click', 'header a', function (e) {
                if ($(this).attr('href').split('#')[1]) {
                    let section = $(this).attr('href').split('#')[1];

                    if (section) {
                        $('html, body').animate({
                            scrollTop: $('#' + section).offset().top - 60
                        }, 1000);
                    }
                }
            });
        }
    },

    toggleShowMoreForPrices() {
        $('.show-more-button').on('click', function (e) {
            e.preventDefault();

            if ($(this).parent().hasClass('with-show-more')) {
                $(this).parent().removeClass('with-show-more');
                $(this).parent().find('.fade').hide();
                $(this).parent().find('.price-content').hide();
                $(this).parent().find('.price-content').slideDown(500);
                $(this).addClass('is-less');
                $(this).text('Toon minder');
            } else {
                $(this).parent().addClass('with-show-more');
                $(this).parent().find('.fade').show();
                $(this).removeClass('is-less');
                $(this).text('Toon meer');
            }
        });
    },

    videoPlayToggle() {
        if ($('.pagehero').hasClass('has-video-mobile')) {
            let windowWidth = $(window).width();

            if (windowWidth > 768) {
                // Handle desktop autoplays
                let videoMobile = $('.pagehero video.sm-show');
                videoMobile.find('source').attr('src', '');

            } else if (windowWidth < 768) {
                let videoDesktop = $('.pagehero video.sm-hide');
                videoDesktop.find('source').attr('src', '');
            }
        }
    },

    formReplaceRequiredWithStar() {
        $('body').find('.form .gform_body .gfield_required_text').each(function () {
            $(this).html('*');
        });
    }
};
$(document).ready($.proxy(app.init, app));
